import { z } from 'zod';

export const itemCategoryDtoSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  parentId: z.string().uuid().nullable(),
  name: z.string(),
  color: z.string(),
  orderItem: z.number().int(),
  active: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const itemCategoryCreateSchema = z.object({
  parentId: z.string().uuid().nullable().optional(),
  name: z.string().min(1).max(255),
  color: z.string().min(1).max(7),
  orderItem: z.number().int().optional(),
  active: z.boolean().optional(),
});

export const itemCategoryUpdateSchema = z.object({
  parentId: z.string().uuid().nullable().optional(),
  name: z.string().min(1).max(255).optional(),
  color: z.string().min(1).max(7).optional(),
  orderItem: z.number().int().optional(),
  active: z.boolean().optional(),
});

export const itemCategoryReorderItemSchema = z.object({
  id: z.string().uuid(),
  parentId: z.string().uuid().nullable(),
  orderItem: z.number().int(),
});

export const itemCategoryReorderSchema = z.object({
  items: z.array(itemCategoryReorderItemSchema).min(1),
});

export type ItemCategoryDto = z.infer<typeof itemCategoryDtoSchema>;
export type ItemCategoryCreateInput = z.infer<typeof itemCategoryCreateSchema>;
export type ItemCategoryUpdateInput = z.infer<typeof itemCategoryUpdateSchema>;
export type ItemCategoryReorderItemInput = z.infer<typeof itemCategoryReorderItemSchema>;
export type ItemCategoryReorderInput = z.infer<typeof itemCategoryReorderSchema>;

export type ItemCategoryTreeNodeDto = {
  category: ItemCategoryDto;
  children: ItemCategoryTreeNodeDto[];
};

export const itemCategoryTreeNodeDtoSchema: z.ZodType<ItemCategoryTreeNodeDto> = z.lazy(() =>
  z.object({
    category: itemCategoryDtoSchema,
    children: z.array(itemCategoryTreeNodeDtoSchema),
  }),
);

export const itemCategoryTreeResponseSchema = z.array(itemCategoryTreeNodeDtoSchema);
